import {
  type AccountStatus,
  type PremiumFeatures,
} from '@/services/types/premiumFeatures/premiumFeatures'

import { create } from 'zustand'

export interface PremiumFeaturesActions {
  setPremiumFeatures: (premiumFeatures: PremiumFeatures[]) => void
  setStatus: (status: AccountStatus) => void
}

export interface PremiumFeaturesState {
  actions: PremiumFeaturesActions
  premiumFeatures: PremiumFeatures[]
  isLoading: boolean
  status: AccountStatus | null
}

const INITIAL_STATE: Omit<PremiumFeaturesState, 'actions'> = {
  premiumFeatures: [],
  isLoading: true,
  status: null,
}

export const usePremiumFeaturesStore = create<PremiumFeaturesState>()((set) => ({
  ...INITIAL_STATE,
  actions: {
    setPremiumFeatures: (premiumFeatures: PremiumFeatures[]) => {
      set(() => ({ premiumFeatures, isLoading: false }))
    },
    setStatus: (status: AccountStatus) => {
      set(() => ({ status }))
    },
  },
}))

export const usePremiumFeaturesPermissions = () =>
  usePremiumFeaturesStore((state) => state.premiumFeatures)
export const usePremiumFeaturesStatus = () => usePremiumFeaturesStore((state) => state.status)
